import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getDetailsBlog } from "./DetailsBlogAPI";

const initialState = {
  blog: {},
  isLoading: false,
  isError: false,
  error: "",
};
export const fetchBlog = createAsyncThunk("blog/fetchBlog", async (blogId) => {
  const blog = await getDetailsBlog(blogId);
  return blog;
});
const BlogSlice = createSlice({
  name: "Blog",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(fetchBlog.pending, (state) => {
      state.isError = false;
      state.isLoading = true;
    });
    builder.addCase(fetchBlog.fulfilled, (state, action) => {
      state.isLoading = false;
      state.blog = action.payload;
    });
    builder.addCase(fetchBlog.rejected, (state, action) => {
      state.isLoading = false;
      state.blog = {};
      state.isError = true;
      state.error = action.error?.message;
    });
  },
});

export default BlogSlice.reducer;
